import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';

interface LoginFormProps {
  onSubmit: (email: string, password: string) => Promise<void>;
  error?: string;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, error }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try { await onSubmit(email, password); } finally { setLoading(false); }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-1">
      {error && <div className="bg-red-50 text-red-600 text-sm p-3 rounded-lg mb-4">{error}</div>}
      <Input className="min-h-[44px]" label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required />
      <Input className="min-h-[44px]" label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
      <div style={{ height: 5 }} />
      <Button type="submit" size="lg" loading={loading} className="w-full min-h-[44px]">Sign In</Button>
      <div className="text-center pt-2">
        <a
          href="mailto:support@intrlock.io?subject=Password%20Reset%20Request"
          className="inline-flex min-h-[44px] items-center text-sm text-gray-500 hover:text-gray-700 underline"
        >
          Forgot Password?
        </a>
      </div>
    </form>
  );
};
